import React from 'react'

const CalendarSkeleton: React.FC = () => {
    return (
        <>
            <div className="flex items-center justify-between mb-4">
                <div className="h-5 bg-gray-200 rounded animate-pulse w-32"></div>
                <div className="w-8 h-8 bg-gray-200 rounded animate-pulse"></div>
            </div>
            <div className="mb-4">
                {/* Skeleton for month title */}
                <div className="flex justify-center items-center mb-3">
                    <div className="h-5 bg-gray-200 rounded animate-pulse w-32"></div>
                </div>

                {/* Week Grid Skeleton */}
                <div className="flex justify-center items-center mb-3">
                    {/* Left arrow skeleton */}
                    <div className="flex items-center justify-center max-w-[34px]">
                        <div className="w-8 h-8 bg-gray-200 rounded-full animate-pulse"></div>
                    </div>

                    <div className="w-full">
                        {/* Day headers skeleton */}
                        <div className="grid grid-cols-7 gap-1 text-center text-xs w-full">
                            {Array.from({ length: 7 }).map((_, index) => (
                                <div key={index} className="p-1">
                                    <div className="h-4 bg-gray-200 rounded animate-pulse w-6 mx-auto"></div>
                                </div>
                            ))}
                        </div>

                        {/* Calendar days skeleton */}
                        <div className="grid grid-cols-7 gap-1 text-center text-xs w-full">
                            {Array.from({ length: 7 }).map((_, index) => (
                                <div
                                    key={index}
                                    className="col-span-1 flex items-center justify-center"
                                >
                                    <div className="w-[34px] h-[34px] bg-gray-200 rounded-full animate-pulse"></div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Right arrow skeleton */}
                    <div className="flex items-center justify-center max-w-[34px]">
                        <div className="w-8 h-8 bg-gray-200 rounded-full animate-pulse"></div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CalendarSkeleton
